import { Box, Typography } from '@mui/material';
import { backendServices, Button, Card } from 'common';

// @ts-expect-error
import iconEDI from './assets/iconEDI.png';
// @ts-expect-error
import iconEmail from './assets/iconEmail.png';
// @ts-expect-error
import iconPrinter from './assets/iconPrinter.png';
// @ts-expect-error
import iconWebEntry from './assets/iconWebEntry.png';

function getIcon(method: backendServices.ViewModels.SubmissionMethod) {
    switch (method) {
        case backendServices.ViewModels.SubmissionMethod.EDI_XML: {
            return iconEDI;
        }
        case backendServices.ViewModels.SubmissionMethod.Email: {
            return iconEmail;
        }
        case backendServices.ViewModels.SubmissionMethod.VirtualPrinter: {
            return iconPrinter;
        }
        case backendServices.ViewModels.SubmissionMethod.WebEntry: {
            return iconWebEntry;
        }
        default: {
            throw new Error('Non-expected submission method');
        }
    }
}

export function SubmissionMethodCard({
    method,
    onButtonClick,
}: {
    method: backendServices.ViewModels.SubmissionMethodViewModel;
    onButtonClick: (method: backendServices.ViewModels.SubmissionMethodViewModel) => void;
}) {
    const submissionMethodKey = backendServices.ViewModels.SubmissionMethod[method.SubmissionMethod];

    return (
        <Card
            rootProps={{
                sx: {
                    display: 'flex',
                    height: '100%',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    width: {
                        xs: '100%',
                    },
                },
                'data-testid': `submission-method-card-${submissionMethodKey}`,
            }}
            headerProps={{
                title: method.Name,
                titleTypographyProps: {
                    textAlign: 'center',
                    variant: 'subtitle1',
                },
            }}
            mediaProps={{
                component: 'img',
                height: '100',
                width: '100',
                image: getIcon(method.SubmissionMethod),
                sx: {
                    objectFit: 'contain',
                },
                alt: 'company submission method',
            }}
            content={
                <Box
                    sx={{
                        maxWidth: { xs: 360, sm: 400, md: 'none' },
                        width: '100%',
                        mx: { xs: 'auto', md: 0 },
                    }}
                >
                    <Typography
                        paragraph
                        sx={{
                            mb: 0,
                            textAlign: { xs: 'center', md: 'left' },
                        }}
                    >
                        {method.Description}
                    </Typography>
                </Box>
            }
            contentProps={{
                sx: {
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: { xs: 'center', md: 'stretch' },
                    width: '100%',
                },
            }}
            actions={
                <Button
                    color="primary"
                    onClick={() => {
                        onButtonClick(method);
                    }}
                >
                    Register
                </Button>
            }
            actionsProps={{
                disableSpacing: true,
                sx: {
                    justifyContent: 'center',
                    pb: 2,
                },
            }}
        />
    );
}
